import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { hiddenElementSlideInOut } from '../../utils/animations/slides.animation';
import { ICartDetails } from '../../interfaces/cart-details.interface';

@Component({
  selector: 'new-offer-details-widget',
  templateUrl: './new-offer-details-widget.component.html',
  animations: [hiddenElementSlideInOut],
  styles: [`
      @media (min-width: 1024px) {
          :host .btn-trigger {
              display: none;
          }
      }
  `]
})

export class NewOfferDetailsWidgetComponent implements OnInit {

  public contractDetailsData: any;
  public headerText: any;
  public isContractListVisible: boolean = true;
  public isVirginBrand: boolean = false;
  public nextSim: boolean;

  constructor(
    public breakpointObserver: BreakpointObserver,
    private notificationProvider: NotificationProviderService,
    private commonInfo: CommonInfoService,
  ) {
    this.isVirginBrand = this.commonInfo.isVirginBrand;

    this.notificationProvider.subscribe(NotificationProviderTypeEnum.CART_DETAILS, (cartDetails: ICartDetails) => {
      if (cartDetails) {
        this.nextSim = cartDetails.nextSim;

        if (cartDetails.contractDetails) {
          this.contractDetailsData = cartDetails.contractDetails.data;
          this.headerText = cartDetails.contractDetails.header.headLine;
        }
      }
    });
  }

  ngOnInit() {
    this.breakpointObserver
      .observe(['(min-width: 1024px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.isContractListVisible = true;
        }
      });
  }

}


